// extracted by mini-css-extract-plugin
export default {"content":"style_content__SYpWM","itemName":"style_itemName__lSdZ2","leftSide":"style_leftSide__luG9b","rightSide":"style_rightSide__Mgqpa","type":"style_type__j9dQW"};